import React from "react";
import PropTypes from "prop-types";
// import Backdrop from "@mui/material/Backdrop";
import { Backdrop } from "@mui/material";
import {CircularProgress} from "@mui/material";
// import CircularProgress from "@mui/material/CircularProgress";

function BackDrop({ isBackdropVisible }) {
  if (isBackdropVisible) {
    return (
      <Backdrop
        style={{ zIndex: "10000", color: "#fff" }}
        open={isBackdropVisible}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return null;
}

BackDrop.propTypes = {
  isBackdropVisible: PropTypes.bool.isRequired
};

export default BackDrop;
